import { mapState } from '@/store/helpers';

const placeHolder = {
    computed: {
        ...mapState({
            keywords: store => store.keywords,
            locationPlaceholder: store => store.locationPlaceholder
        }),
        //  deal with placeholder
        keywordPlaceholders() {
            //  modular config data ？
            if (this.keywordsPlaceholder) {
                return this.keywordsPlaceholder;
            }
            if (this.keywords.length) {
                return this.$t('md-search-bar.enterAnotherRegion');
            }
            return (
                this.locationPlaceholder &&
                this.$t('md-search-bar.etc', {
                    names: this.locationPlaceholder
                })
            );
        }
    }
};
const placeHolderCenter = {
    computed: {
        ...mapState({
            keywords: store => store.keywords,
            fetcherData: store => store.fetcherData
        }),
        keywordPlaceholders() {
            if (this.keywordsPlaceholder) {
                return this.keywordsPlaceholder;
            }
            if (this.keywords.length) {
                return this.$t('md-search-bar.enterAnotherRegion');
            }
            if (
                !this.fetcherData ||
                (this.fetcherData.location &&
                    !this.fetcherData.location.condition)
            ) {
                return '';
            }
            if (!this.fetcherData.location) {
                return '';
            }
            return this.$t('md-search-bar.etc', {
                names: this.fetcherData.location.placeholder
            });
        }
    }
};

export { placeHolder, placeHolderCenter };
